import { CheckCircle2, AlertTriangle, XCircle, Rocket, X } from "lucide-react";
import { Button } from "@/components/ui/button";

// Modale de contrôle SEO avant publication.
export default function SeoChecklist({ open, result, onClose, onPublishAnyway }) {
  if (!open || !result) return null;
  const color = result.score >= 80 ? "text-emerald-600" : result.score >= 50 ? "text-amber-600" : "text-rose-600";
  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4" onClick={onClose} data-testid="seo-modal">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md max-h-[80vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-5 py-3 border-b border-slate-200">
          <div className="font-heading font-bold text-slate-900">Contrôle SEO avant publication</div>
          <button onClick={onClose} className="p-1 text-slate-400 hover:text-slate-700"><X size={18} /></button>
        </div>
        <div className="p-5">
          <div className="text-center mb-4">
            <div className={`text-4xl font-extrabold ${color}`} data-testid="seo-score">{result.score}</div>
            <div className="text-xs text-slate-400">score SEO / 100</div>
          </div>
          <div className="space-y-1.5">
            {result.warnings.map((w, i) => (
              <div key={`w${i}`} className="flex items-start gap-2 text-sm" data-testid={`seo-warn-${i}`}>
                {w[0] === "error" ? <XCircle size={16} className="text-rose-500 mt-0.5 shrink-0" /> : <AlertTriangle size={16} className="text-amber-500 mt-0.5 shrink-0" />}
                <span className="text-slate-700">{w[1]}</span>
              </div>
            ))}
            {result.oks.map((o, i) => (
              <div key={`o${i}`} className="flex items-start gap-2 text-sm text-slate-500">
                <CheckCircle2 size={16} className="text-emerald-500 mt-0.5 shrink-0" /><span>{o}</span>
              </div>
            ))}
          </div>
          <div className="mt-5 flex gap-2">
            <Button variant="outline" className="flex-1" onClick={onClose} data-testid="seo-cancel">Corriger d'abord</Button>
            <Button className="flex-1 bg-[#E05638] text-white" onClick={onPublishAnyway} data-testid="seo-publish-anyway"><Rocket size={15} className="mr-1.5" /> Publier</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
